import _ from 'lodash'
import config from 'scoreboard/components/config'
import currency from 'scoreboard/components/currency'
import permissions from 'scoreboard/components/permissions'

/**
 * @returns an array of fields that can be used to mass edit scorecard items
 * The returned fields are filtered based on permissions and app config
 *
 */
function massEditFields() {
	let fields = [{
		value: 'label',
		label: 'common.name',
		icon: 'text',
		group: 'all'
	}, {
		value: 'description',
		label: 'common.description',
		icon: 'text',
		group: 'all'
	}, {
		value: 'owners',
		label: 'common.owners',
		icon: 'group',
		group: 'all'
	}, {
		value: 'tags',
		label: 'common.tags',
		icon: 'text',
		group: 'all'
	}, {
		value: 'weight',
		label: 'scorecards.node.weight',
		icon: 'percent',
		group: 'all'
	}, {
		value: 'start',
		label: 'admin.scorecards.hideBefore',
		icon: 'calendar',
		group: 'all'
	}, {
		value: 'archive',
		label: 'admin.scorecards.hideAfter',
		icon: 'calendar',
		group: 'all'
	}, {
		value: 'type',
		label: 'report.customReport.subtype',
		icon: 'text',
		group: 'all'
	}, {
		value: 'updaters',
		label: 'common.updaters',
		icon: 'group',
		group: 'kpi-only'
	}, {
		value: 'data-type',
		label: 'scorecards.node.metric.dataType.dataType',
		icon: 'text',
		group: 'kpi-only'
	}, {
		value: 'precision',
		label: 'scorecards.node.metric.decimalPrecision',
		icon: 'number',
		group: 'kpi-only'
	}, {
		value: 'aggregation-type',
		label: 'scorecards.node.metric.aggregationType.aggregationType',
		icon: 'text',
		group: 'kpi-only'
	}, {
		value: 'rollup-aggregation-type',
		label: 'scorecards.node.metric.aggregationType.aggregationType.rollup',
		icon: 'text',
		group: 'kpi-only'
	}, {
		value: 'missing-value-treatment',
		label: 'scorecards.node.metric.missingValues',
		icon: 'text',
		group: 'kpi-only'
	}, {
		value: 'higher-better',
		label: 'scorecards.node.metric.higherValuesBetter',
		icon: 'yes-no-data-type',
		group: 'kpi-only'
	}, {
		value: 'yes-good',
		label: 'scorecards.node.metric.isYesGood',
		icon: 'yes-no-data-type',
		group: 'kpi-only'
	}, {
		value: 'currency-code',
		label: 'common.currency',
		icon: 'currency',
		group: 'kpi-only'
	}, {
		value: 'unit',
		label: 'scorecards.node.metric.dataType.units',
		icon: 'text',
		group: 'kpi-only'
	}, {
		value: 'equation',
		label: 'scorecards.node.metric.equation',
		icon: 'text',
		group: 'kpi-only'
	}, {
		value: 'default-threshold',
		label: 'admin.import.scorecard.metric.defaultThreshold',
		icon: 'number',
		group: 'kpi-only'
	}, {
		value: 'scoring-type-id',
		label: 'report.customReport.scoringType',
		icon: 'text',
		group: 'kpi-only'
	}, {
		value: 'update-type',
		label: 'scorecards.node.metric.updateType.updateType',
		icon: 'text',
		group: 'kpi-only'
	}, {
		value: 'calendar-id',
		label: 'common.calendar.calendar',
		icon: 'calendar',
		group: 'kpi-only'
	}]

	// filter out fields that should not  available
	if (_.isEmpty(config.units)) {
		_.remove(fields, field => field.value === 'unit')
	}
	// Remove currency if less than two configured for this application
	if (_.size(currency.all()) < 2) {
		_.remove(fields, field => field.value === 'currency-code')
	}
	// Remove dropdown choices for fields that user does not have permission to change
	if (!permissions.anyStructure()) {
		// remove all fields except owners and updaters if cannot modify structure
		_.remove(fields, field => field.value !== 'owners' && field.value !== 'updaters')
	}
	if (!permissions.anyOwnerUpdaters()) {
		// remove owners and updaters if the user does not have the permission
		_.remove(fields, field => field.value === 'owners' || field.value === 'updaters')
	}

	return fields
}

/**
 * map correlating a  MassEditField json text value to the equivalent column
 * (found in scorecard-report-columns.js)
*/
const massEditFieldsToColumns = {
	'label': 'label',
	'description': 'description',
	'weight': 'weight',
	'start': 'start',
	'archive': 'archive',
	'type': 'item-type',
	'owners': 'owners',
	'updaters': 'updaters',
	'data-type' : 'data-type',
	'aggregation-type': 'aggregation-type',
	'calendar-id': 'calendar-id',
	'tags': 'tags',
	'precision': 'precision',
	'scoring-type-id' : 'scoring-type-id',
	'unit': 'unit' ,
	'currency-code': 'currency-code',
	'equation': 'equations',
	'missing-value-treatment': 'missing-value-treatments',
	'update-type': 'update-type',
	'rollup-aggregation-type': 'rollup-aggregation-type',
	'default-threshold': 'thresholds',
	'higher-better': 'higher-better',
	'yes-good': 'yes-good'
}

export default massEditFields
export { massEditFieldsToColumns }
massEditFields.__filename__ = 'admin/mass-edit/mass-edit-fields.js'
